import InternalModules from '@/models/InternalModules';

export default function () {
  const urlParams = new URLSearchParams(window.location.search);

  //Try exact match first
  const exact = urlParams.get('embeddedIn');
  let moduleName = '';
  if (exact !== null) {
    moduleName = exact.toLocaleLowerCase();
  }

  //Fallback - look for any case-insensitive match
  for (const [key, value] of urlParams.entries()) {
    if (key.toLowerCase() === 'embeddedin') {
      moduleName = value.toLocaleLowerCase();
      break;
    }
  }

  return moduleName === InternalModules.ScreeningCenter ||
    moduleName === InternalModules.Siu
    ? moduleName
    : '';
}
